<template>
	<slot />
</template>

<style lang="scss">
.placeholder-for-empty-style-tag {
	display: block;
}

.news-info {
	align-items: center;
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	margin-bottom: 24px;

	@include media('>tablet') {
		margin-bottom: 32px;
	}
}

.news-date {
	color: $text-secondary;
}

.news-topics {
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
}

.news-topic {
	background-color: $bg-gray-3;
	border-radius: 8px;
	padding: 2px 8px;
}
</style>
